import {IWaveFormRegions} from './WaveForm';

type K = keyof IWaveFormRegions;

export const UpdateRegions = (options: {
  regions: IWaveFormRegions[];
  id: string;
  key: K;
  value: IWaveFormRegions[K];
}) => {
  const {regions, id, key, value} = options;
  return regions.map(region => {
    if (region.id === id) {
      return {
        ...region,
        [key]: value,
      };
    }
    return region;
  });
};
